"use client";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { productInfo, productKeyMap } from "@/config/productInfo";
import { cn } from "@/lib/utils";
import styles from "./sceneList.module.scss";

export default function SceneListEle() {
  const path = usePathname(),
    curPath = path.split("/").slice(-1)[0] as keyof typeof productKeyMap;

  const infoList = productInfo[productKeyMap[curPath]];
  const sceneList = infoList?.sceneList || [];
  return (
    <section className="bg-[#f0f2f5]">
      <div className="container p-6 md:py-20 md:px-0">
        <h4 className="text-2xl md:text-3xl mb-5 md:mb-12 text-center">
          应用场景
        </h4>
        {/* <div className="grid grid-cols-3 gap-x-3 mb-3 md:gap-x-5 md:mb-5">
        {sceneList.slice(0, 3).map((item, idx) => (
          <div
            className="flex items-center py-4 sm:py-6 md:p-8 bg-white rounded space-y-2 md:space-y-0 md:space-x-7 flex-col md:flex-row"
            key={idx}
          >
            {deviceType.isMobile ? (
              <Image
                src={`/product/zerotrust/scene${idx + 1}.png`}
                className="w-[40px] h-[40px]"
                alt="scene"
                width="80"
                height="80"
                quality={100}
              />
            ) : (
              <Image
                src={`/product/zerotrust/scene${idx + 1}.png`}
                className="w-[70px] h-[70px]"
                alt="scene"
                width="80"
                height="80"
                quality={100}
              />
            )}

            <span className="text-xs font-bold md:font-normal md:text-xl text-[#333333]">
              {item}
            </span>
          </div>
        ))}
      </div> */}
        {/* <div className="grid md:grid-cols-4 gap-3 grid-cols-2"> */}
        <div className="grid md:grid-cols-4 gap-3 grid-cols-2">
          {sceneList.map((item, idx) => (
            <div
              className={cn(
                `flex-1 flex-center bg-white rounded md:space-y-3
                  md:flex-col p-3 sm:p-5 md:p-8  space-x-[10px] sm:space-x-3 md:space-x-0
                  justify-start md:justify-center
                  `,
                //4 | 6
                "min-w-[40%]",
                sceneList.length === 4 ? "md:min-w-[24%]" : "sm:min-w-[30%]",
                //sceneList.length === 4 ? styles.gridItem4 : styles.gridItem6
              )}
              key={idx}
            >
              {/* <Image
                src={`/mobile/product/zerotrust/scene${idx + 1}.png`}
                className="w-8 h-8 block md:hidden"
                alt="scene"
                width="80"
                height="80"
                quality={100}
              />*/}
              <Image
                src={`/product/${curPath}/${idx + 1}.png`}
                className="w-8 md:w-[70px] h-8 md:h-[70px]"
                alt="scene"
                width="80"
                height="80"
                quality={100}
              />
              <span className="text-[#333333]  md:font-normal text-xs sm:text-base md:text-xl whitespace-nowrap">
                {item.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
